interface ToastProps {
  message: string;
  visible: boolean;
}

export default function Toast({ message, visible }: ToastProps) {
  if (!visible) return null;
  return (
    <div className="pointer-events-none fixed bottom-8 left-1/2 z-[70] -translate-x-1/2 animate-fade-up">
      <div className="flex items-center gap-2 rounded-md bg-foreground-950 px-4 py-2.5 text-sm text-background-50">
        <i className="ri-checkbox-circle-fill text-primary-400" />
        {message}
      </div>
    </div>
  );
}